<p-paginator [rows]="rows" [totalRecords]="totalRecords" [first]="(currentPage - 1) * rows"
  [rowsPerPageOptions]="showRowsPerPageOptions ? rowsPerPageOptions : undefined" (onPageChange)="onPageChange($event)">
</p-paginator>